import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import Frame from '../../Wrappers/Frame';
import { testWindow } from '../../Wrappers/MainWindow';
import ApplyMenu from './ApplyMenu';
import { offer } from '../../../services/api';
import { instagramRound } from '../../../helpers';
import * as applyOffersActions from '../../../redux/applyOffers';
import instagramIcon from '../../../svg/instagram-icon.svg';
import noApplicants from '../../../svg/no-applicants.svg';
import './apply-offer.scss';

interface Props {
  match: any;
  location: any;
  applyOffers: any;
  fetchOffer: Function;
  goToApplicant: Function;
  changeFilter: Function;
  sortApplicants: Function;
}

class ApplyOffer extends React.Component<Props> {
  // On mount, we fetch the offer that is being viewed and filter the attendees
  // to those who are "unreviewed", since this is the default view.
  componentDidMount() {
    let filter;
    if (this.props.location.state && this.props.location.state.filter) {
      filter = this.props.location.state.filter;
    }
    this.props.fetchOffer(this.props.match.params.offerId, filter);
  }

  // Change the filter view and update the attendees list to those who have the
  // currently selected status.
  changeStatusView(filter: ApplyOfferApplicantStatus) {
    this.props.changeFilter(this.props.applyOffers.offer.id, filter);
  }

  // Finalize the offer
  finalizeOffer() {
    if (moment(this.props.applyOffers.offer.deliberation_starts).isAfter()) return;

    offer
      .finalizeOffer(this.props.applyOffers.offer)
      .then(() => {
        window.location.replace(`${window.location.origin}/offers/active`);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getBanner(applicant) {
    let banner: any = null;

    if (applicant.is_cancelled) {
      banner = <div className="banner canceled">Canceled</div>;
    } else if (this.props.applyOffers.selectedFilter === 'selected') {
      if (applicant.is_locked) {
        banner = <div className="banner finalized">finalized</div>;
      } else {
        banner = <div className="banner selected">selected</div>;
      }
    }
    return banner;
  }

  // Builds the list of current applicants.
  listApplicants() {
    const applicants: JSX.Element[] = [];

    const available_spots = this.props.applyOffers.offer.available_spots;
    const selectedBucket = this.props.applyOffers.buckets.find(
      (bucket) => bucket.name === 'selected'
    );
    const remainingSpots = available_spots - selectedBucket.count_of_models;

    if (this.props.applyOffers.applicants.length === 0) {
      applicants.push(
        <div key="empty" className="no-applicants">
          <img src={noApplicants}></img>
          <p className="text">No applicants here.</p>
        </div>
      );
    } else {
      if (this.props.applyOffers.selectedFilter === 'selected') {
        const isDisabled = moment(this.props.applyOffers.offer.deliberation_starts).isAfter();

        applicants.push(
          <div className="finalize-wrapper" key="finalize-wrapper">
            <div className="content">
              <p className="remaining-spots">
                {remainingSpots} {remainingSpots === 1 ? 'spot' : 'spots'} remaining
              </p>
              <p className="max-number">
                The maximum number of models you can finalize is {available_spots}
              </p>
              <p className="final">Your selections are final.</p>
            </div>
            <button disabled={isDisabled} onClick={() => this.finalizeOffer()}>
              FINALIZE
            </button>
          </div>
        );
      }

      for (let applicant of this.props.applyOffers.applicants) {
        applicants.push(
          <div
            className={applicant.is_cancelled ? 'applicant canceled' : 'applicant'}
            onClick={() =>
              !applicant.is_cancelled
                ? this.props.goToApplicant(
                    `/offer/apply/${this.props.match.params.offerId}/applicant/${applicant.id}`,
                    applicant
                  )
                : null
            }
            key={applicant.model.name}
          >
            <div className="portrait-wrapper">
              {this.getBanner(applicant)}
              <img className="portrait" src={applicant.model.avatar}></img>
            </div>
            <h2>{applicant.model.first_name}</h2>
            <h2>{applicant.model.last_name}</h2>
            {applicant.model.instagram ? (
              <p className="instagram-number">
                <img className="icon" src={instagramIcon}></img>{' '}
                {instagramRound(applicant.model.instagram.number_of_followers)}
              </p>
            ) : null}
          </div>
        );
      }
    }

    return <>{applicants}</>;
  }

  render() {
    if (!this.props.applyOffers.offer || this.props.applyOffers.loading)
      return <div className="loading">Loading offer...</div>;

    if (this.props.applyOffers.offer.deliberation_status === 'finalized') {
      window.location.replace(`${window.location.origin}/offers/active`);
      return null;
    }

    return (
      <Frame
        classes="apply-offer text-greyish-brown"
        title={this.props.applyOffers.offer.subtitle + ' > ' + this.props.applyOffers.selectedFilter.capitalize()}
        fullHeight={true}
      >
        <ApplyMenu buttonAction={this.changeStatusView.bind(this)} />

        <div className="sort-container">
          Sort applicants:{' '}
          <select
            onChange={(e) => this.props.sortApplicants(e.target.value)}
            name="sort-applicants"
            id="sort-applicants"
            value={this.props.applyOffers.sorting}
          >
            <option value="alphabetically">Alphabetically A-Z</option>
            <option value="alphabetically-reversed">Alphabetically Z-A</option>
            <option value="most-recent">Applied Most Recently</option>
            <option value="least-recent">Applied Least Recently</option>
            <option value="ig-greatest">IG Followers Greatest to Fewest</option>
            <option value="ig-fewest">IG Followers Fewest to Greatest</option>
          </select>
        </div>

        <section className="applicants-list">{this.listApplicants()}</section>
      </Frame>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(testWindow(ApplyOffer, 'offers'));
